








import Vue from 'vue';
export default Vue.extend({
    name: 'DvEmpty',
    props: {
        message: { type: String, default: 'Nothing here.' },
        iconClass: { type: String, default: 'fa-inbox' },
    },
});
